module.exports = __webpack_public_path__ + "static/media/MFA-Background-007.c2737338.png";